<ng-container
  *ngIf="{
  groupInfo: groupInfo$ | async,
  clubInfo: clubInfo$ | async
} as data"
>
  <ng-container *ngIf="data.clubInfo || data.groupInfo; else loading">
    <app-club-container *ngIf="data.clubInfo" [club]="data.clubInfo" [messageCtx]="messageCtx" [postsCtx]="postsCtx">
    </app-club-container>

    <ng-container *ngIf="data.groupInfo as groupInfo">
      <div
        class="container d-block d-md-flex"
        *ngIf="groupInfo"
        appMobileView
        [tabs]="{left: 'About group', middle: 'All posts'}"
      >
        <div class="left-column d-md-block">
          <app-loader-2 *ngIf="!groupInfo"></app-loader-2>
          <div class="profile-information block" *ngIf="groupInfo">
            <button class="profile-menu-btn" *ngIf="isAuthor$ | async">
              <svg viewBox="0 0 20 20">
                <use href="#menu-dots" />
              </svg>

              <div class="options-menu">
                <a href="" class="menu-item d-flex" (click)="onEditGroup(groupInfo); false">
                  <div class="icon">
                    <svg viewBox="0 0 15 15">
                      <use href="#sub-edit-profile" />
                    </svg>
                  </div>
                  Edit group
                </a>
                <a href="" class="menu-item d-flex" (click)="onRemove(groupInfo); false">
                  <div class="icon">
                    <svg viewBox="0 0 15 15">
                      <use href="#sub-delete" />
                    </svg>
                  </div>
                  Remove
                </a>
              </div>
            </button>

            <div class="profile-top group-top">
              <!--          <ng-container *ngIf="groupInfo$ | async as info">-->
              <!--            <app-group-menu *ngIf="info.is_autor || info.is_editor || info.is_subscriber"-->
              <!--                            [group]="groupInfo$ | async"></app-group-menu>-->
              <!--          </ng-container>-->
              <div class="background"></div>
              <div class="d-flex align-items-center position-relative">
                <div class="profile-avatar">
                  <div class="avatar rounded-circle">
                    <img [src]="groupInfo.icon | baseUrl" alt="profile-name" class="img-fluid" />
                  </div>
                </div>
                <div class="profile-name mb-0"> {{groupInfo.name}} </div>
              </div>
              <div class="profile-actions d-flex">
                <button
                  class="action d-flex align-items-center justify-content-center"
                  (click)="joinEventsGroup(groupInfo); false"
                  [disabled]="isAuthor$ | async"
                >
                  <span class="icon">
                    <svg viewBox="0 0 20 20">
                      <use href="#join-group"></use>
                    </svg>
                  </span>
                  <div> {{ groupInfo.is_subscriber || groupInfo.is_requested ? 'Unsubscribe' : 'Join group' }} </div>
                </button>
                <button
                  class="action d-flex align-items-center justify-content-center"
                  (click)="invite()"
                  *ngIf="groupInfo.is_subscriber || groupInfo.access !== 3"
                >
                  <span class="icon">
                    <svg viewBox="0 0 15 15">
                      <use href="#sub-invite" />
                    </svg>
                  </span>
                  <div>Invite members</div>
                </button>
              </div>
            </div>
            <div class="enumerations">
              <div class="enumeration-item d-flex">
                <div [icon]="'CREATOR'"></div>
                <span>
                  Created:
                  <a [profile]="groupInfo.user"> {{ groupInfo.user.name }} </a>
                </span>
              </div>

              <div class="enumeration-item d-flex">
                <span class="icon">
                  <svg viewBox="0 0 20 20">
                    <use href="#group" />
                  </svg>
                </span>
                <span> Members <a>{{ groupInfo.members }}</a> </span>
              </div>
              <!--          <div class="enumeration-item d-flex">-->
              <!--            <div class="icon">-->
              <!--              <svg viewBox="0 0 20 20">-->
              <!--                <use href="#group" /></svg>-->
              <!--            </div>-->
              <!--            <span>-->
              <!--              Members <a>{{ groupInfo.members }}</a>-->
              <!--            </span>-->
              <!--          </div>-->
              <div class="enumeration-item d-flex">
                <div class="icon">
                  <svg viewBox="0 0 20 20">
                    <use href="#student" />
                  </svg>
                </div>
                <span> Age Group: <i>{{groupInfo.agegroup.name | clearAgeGroup}}</i> </span>
              </div>

              <div class="enumeration-item d-flex" [ngSwitch]="groupInfo.access">
                <div class="icon">
                  <svg viewBox="0 0 20 20">
                    <use href="#privateGroup" />
                  </svg>
                </div>
                <span *ngSwitchCase="1"> Group access: <i>Open for all</i> </span>
                <span *ngSwitchCase="2"> Group access: <i>Open to RoundPier members</i> </span>
                <span *ngSwitchCase="3"> Group access: <i>Private Group - only by invitations</i> </span>
              </div>
            </div>
            <div class="about-block">
              <div class="title">About group</div>
              <div> {{groupInfo.description}} </div>
            </div>

            <!--        <div class="enumerations">-->
            <!--          <div class="title">Keywords</div>-->
            <!--          <div class="boxes d-flex flex-wrap">-->
            <!--            <div class="enumeration-box" *ngFor="let keyword of groupInfo.keywords">{{keyword.name}}</div>-->
            <!--          </div>-->
            <!--        </div>-->
            <!--        <div class="enumerations">-->
            <!--          <div class="title">Share</div>-->
            <!--          <div class="enumeration-item d-flex">-->
            <!--            <img src="/assets/new_img/image%207.png" alt="" class="img-fluid">-->
            <!--          </div>-->
            <!--        </div>-->
          </div>

          <app-suggested-articles *appHideForGuest [articles]="articles$ | async"></app-suggested-articles>
        </div>

        <section class="middle-column d-md-block">
          <ng-container *appHideForGuest>
            <app-message *ngIf="isCanSendMessage$ | async" [ctx]="messageCtx" class="message"></app-message>
          </ng-container>

          <app-posts
            [posts]="groupPosts$ | async"
            [ctx]="postsCtx"
            [isGroupPosts]="true"
            [isPrivateGroup]="(groupInfo.access === 3)"
            [isSubscriber]="groupInfo.is_subscriber"
            [hideMargin]="!(groupInfo.is_author || groupInfo.is_editor || groupInfo.is_subscriber)"
          ></app-posts>
        </section>

        <div class="right-column d-none d-xl-block" *appHideForGuest>
          <div
            class="block right-block"
            *ngIf="!(requests$ | async).loadRequests && (requests$ | async).requests?.length"
          >
            <div class="title d-flex">
              New request
              <span class="ml-auto" *ngIf="(requests$ | async).requests?.length"
                >{{ (requests$ | async).requests?.length }}</span
              >
            </div>
            <div class="right-block-data" *ngIf="(requests$ | async).loadRequests">
              <app-loader-2></app-loader-2>
            </div>
            <div class="right-block-data" *ngIf="!(requests$ | async).loadRequests">
              <div class="members-list">
                <div class="member-item d-flex" *ngFor="let request of (requests$ | async).requests">
                  <div class="avatar rounded-circle">
                    <div class="d-none d-lg-block">
                      <a [profile]="request">
                        <img [src]="request.icon | baseUrl" alt="profile-name" class="img-fluid" />
                      </a>
                    </div>
                  </div>
                  <div class="data">
                    <div class="d-none d-lg-block">
                      <a [profile]="request" class="name">{{request.name}}</a>
                    </div>
                    <div class="position">{{request.type_name}}</div>
                    <div class="actions d-flex">
                      <div class="action accept" (click)="onAccept(request)">Accept</div>
                      <div class="action reject" (click)="onReject(request)">Reject</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TODO: probably show section with text that there are no data to display -->
          <div class="block right-block" *ngIf="(members$ | async).members?.length">
            <div class="title d-flex justify-content-between">
              Group members
              <app-loader-three-dots *ngIf="(members$ | async).loadMembers"></app-loader-three-dots>
            </div>
            <div
              class="right-block-data right-block-data-group-members"
              infiniteScroll
              [scrollWindow]="false"
              (scrolled)="onLoadMoreMembers()"
            >
              <div class="members-list">
                <app-group-view-member
                  class="member-item d-block"
                  [isAdminView]="isAdminView$ | async"
                  [isMe]="user.id | isCurrentUser | async"
                  [user]="user"
                  (groupViewMemberProfileConnect)="onProfileConnect($event)"
                  (groupViewMemberProfileDisconnect)="onProfileDisconnect($event)"
                  (groupViewMemberUpdateToModerator)="onGroupViewMemberUpdateToModerator($event)"
                  (groupViewMemberUpdateToMember)="onGroupViewMemberUpdateToMember($event)"
                  *ngFor="let user of (members$ | async).members"
                >
                </app-group-view-member>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loading>
  <app-loader-2></app-loader-2>
</ng-template>

<!-- TODO: Should be on the parent level -->
<app-confirm-dialog></app-confirm-dialog>
